import Icon from '@mui/material/Icon';
import React, { useEffect, useState } from 'react';
import { Button, Badge, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import Close from '../assets/delete.svg';
import ConfigHandler from '../config';
import { RestService } from '../utils';
import Utils from '../utils/Utils';
import QuoteCoverageTable from './QuoteCoverageTable';

const FeasibilitySite = ({ formData, setFormData }) => {
  const [locationMethod, setLocationMethod] = useState('address');
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedStreet, setSelectedStreet] = useState(null);
  const [hasBuildingNumbers, setHasBuildingNumbers] = useState(false);
  const [selectedStreetNumber, setSelectedStreetNumber] = useState(null);
  const [selectedBuildingNumber, setSelectedBuildingNumber] = useState({ civico: "", scala: "" });
  const [validated, setValidated] = useState(false);
  const [isLoadingContent, setIsLoadingContent] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [tableParams, setTableParams] = useState({ istat: null, egon: null, civico: null, scala: null });
  const [listData, setData] = useState(null);
  const { t } = useTranslation();
  let debounceMunicipality = null;
  let debounceStreets = null;

  let dataReturn = {};

  const handleChange = (complete) => {
    setFormData({
      ...formData,
      ["city"]: selectedCity ? selectedCity.nome : '',
      ["street"]: selectedStreet ? selectedStreet.strada : '',
      ["streetNumber"]: selectedStreetNumber ? selectedStreetNumber.civico : '',
      ["buildingNumber"]: selectedBuildingNumber ? selectedBuildingNumber.scala : '',
      ["codiceIstat"]: selectedCity ? selectedCity.codiceIstat : '',
      ["codiceEgon"]: selectedStreet ? selectedStreet.codiceEgon : '',
      ["sitecomplete"]: complete
    });
  };

  useEffect(() => {
    let complete =
      ((selectedStreetNumber) && (selectedStreetNumber.civico))
        ||
        ((selectedBuildingNumber) && (selectedBuildingNumber.scala))
        ? '1' : '0'
    handleChange(complete);
    //console.log("FeasibilitySite 58", complete);
  }, [selectedCity, selectedStreet, selectedStreetNumber, selectedBuildingNumber])

  //Custom Styles for React-Select
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      border: '1px solid  rgb(168, 168, 168)',
      alignText: 'left !important',
    }),
    control: (base, state) => ({
      ...base,
      boxShadow: 'none',
      border: state.isFocused && 'none',
      '&:focus-within': {
        border: '1px solid #ed3a7f',
        boxShadow: '0 0 0 3px rgba(255, 211, 198, 0.38)',
      },
      '&:invalid': {
        border: '1px solid green',
      },
    }),
  };

  // handleSelections
  const handleCity = (value) => {
    console.error('***HANDLE CITY***');
    setSelectedBuildingNumber(null);
    setSelectedStreetNumber(null);
    setSelectedStreet('');
    setSelectedCity(value);

    setData(null);
    //localStorage.removeItem(`SITE-FEASIBILITY`);
  };

  const handleStreet = (value) => {
    console.error('***HANDLE STREET***');
    setSelectedBuildingNumber(null);
    setSelectedStreetNumber(null);
    setSelectedStreet(value);

    setData(null);
    //localStorage.removeItem(`SITE-FEASIBILITY`);
  };

  const handleStreetNumber = (value) => {
    console.error('***HANDLE STREET NUMBER***');
    setSelectedBuildingNumber(null);
    setSelectedStreetNumber(value);

    setData(null);
    //localStorage.removeItem(`SITE-FEASIBILITY`);
  };

  const handleBuildingNumber = (value) => {
    console.error('***HANDLE BUILDING NUMBER***');
    setSelectedBuildingNumber(value);

    setData(null);
    //localStorage.removeItem(`SITE-FEASIBILITY`);
  };

  const debounceTimeout = 666;

  const loadMunicipality_delayed = (value, callback) => {
    //console.log('loadMunicipality_delayed',value);
    if (debounceMunicipality) clearTimeout(debounceMunicipality);
    if (value) debounceMunicipality = setTimeout(() => { loadMunicipality(value, callback); }, debounceTimeout);
  }

  const loadStreets_delayed = (value, callback) => {
    //console.log('loadStreets_delayed',value);
    if (debounceStreets) clearTimeout(debounceStreets);
    if (value) debounceStreets = setTimeout(() => { loadStreets(value, callback); }, debounceTimeout);
  }

  const loadMunicipality = (inputValue, callback) => {
    console.error('***LOAD MUNICIPALITY***');
    //clearTimeout(debounceMunicipality);
    //console.log('loadMunicipality',inputValue);
    if (inputValue.length >= ConfigHandler.getConfig().defaults.minInputLength) {
      return Utils.handleInputSearch(inputValue).then((text) => {
        return RestService.get({
          //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getMunicipality}?q=${text}`,
          url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuComuni}?q=${text}`,
          showLoader: false
        }).then((response) =>
          response.json()
            .then((data) => ({ data }))
            .then((res) => {
              if (response.status == 200) {
                console.error('***LOAD MUNICIPALITY - RES***');
                callback(res.data);
                return res.data;
              } else {
                setErrorMessage(true);
                return []
              }
            }),
        )
      });
    }
  };

  const loadStreets = (inputValue, callback) => {
    console.error('***LOAD STREETS***');
    //clearTimeout(debounceStreets);
    //console.log('loadStreets',inputValue);
    if (inputValue.length >= ConfigHandler.getConfig().defaults.minInputLength) {
      if (selectedCity != null) {
        return Utils.handleInputSearch(inputValue).then((text) => {
          return RestService.get({
            //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getStreet}?istatCode=${selectedCity.codiceIstat}&q=${inputValue}`,
            url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuIndirizzi}?pkCode=${selectedCity.pk}&q=${inputValue}`,
            showLoader: false
          }).then((response) =>
            response.json()
              .then((data) => ({ data, }))
              .then((res) => {
                if (response.status == 200) {
                  console.error('***LOAD STREETS - RES***');
                  callback(res.data);
                  return res.data;
                } else {
                  setErrorMessage(true);
                  return []
                }
              }),
          );
        });
      }
    }
  };

  const loadStreetNumber = (inputValue, callback) => {
    console.error('***LOAD STREET NUMBER***');
    //console.log('loadStreetNumber',inputValue);
    if (selectedCity != null) {
      return RestService.get({
        //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getStreetNumber}?istatCode=${selectedCity.codiceIstat}&egonCode=${selectedStreet.codiceEgon}&q=${inputValue}`,
        url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuCivici}?pkCode=${selectedCity.pk}&indirizzo=${selectedStreet.indirizzo}&q=${inputValue ? inputValue : "*"}`,
        showLoader: false
      }).then((response) =>
        response.json()
          .then((data) => ({ data, }))
          .then((res) => {
            if (response.status == 200) {
              console.error('***LOAD STREET NUMBER - RES***');
              if (inputValue != '') res.data = res.data.filter((item) => { return item.civico.startsWith(inputValue); });
              callback(res.data);
              return res.data;
            } else {
              setErrorMessage(true);
              return []
            }
          }),
      );
    }
  };

  const loadBuildingNumber = (inputValue, callback) => {
    console.error('***LOAD BUILDING NUMBER***');
    //console.log('loadBuildingNumber',inputValue);
    setHasBuildingNumbers(false);
    if (selectedStreetNumber != null) {
      return RestService.get({
        //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getBuildingNumber}?istatCode=${selectedCity.codiceIstat}&egonCode=${selectedStreet.codiceEgon}&streetNumber=${selectedStreetNumber.civico}&q=${inputValue}`,
        url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuScale}?codIstat=${selectedCity.cod_comune_alfa}&partTop=${selectedStreet.part_top}&indirizzo=${selectedStreet.strada}&civico=${selectedStreetNumber.civico}&q=${inputValue}`,
        showLoader: false
      }).then((response) =>
        response.json()
          .then((data) => ({ data, }))
          .then((res) => {
            if (response.status == 200) {
              res.data = res.data.filter((item) => { return item.scala.startsWith(inputValue); });
              setHasBuildingNumbers(res.data.length > 0);
              callback(res.data);
              return res.data;
            } else {
              setErrorMessage(true);
              return []
            }
          }),
      );
    }
  };

  /*  
    const HandleSubmit = (event) => {
      const form = event.currentTarget;
      event.preventDefault();
  
      if (form.checkValidity() === false || selectedCity === null || selectedStreet === null) {
        event.stopPropagation();
        setValidated(false);
  
        setData(null);
        return null;
      }
  
      setValidated(true);
      setTableParams({ istat: selectedCity.codiceIstat, egon: selectedStreet ? selectedStreet.codiceEgon : '', civico: selectedStreetNumber ? selectedStreetNumber.civico : '' });
  
      localStorage.setItem(`SITE-FEASIBILITY`, JSON.stringify({ istat: selectedCity.codiceIstat }));
    };
  */

  const options = [
    {
      label: 'Address',
      value: 'address',
      selectedBackgroundColor: '#fee8e6',
      selectedFontColor: '#ff6033',
    },
    {
      label: 'Coordinates',
      value: 'coordinates',
      selectedBackgroundColor: '#fee8e6',
      selectedFontColor: '#ff6033',
    },
  ];

  const initialSelectedIndex = options.findIndex(({ value }) => value === 'address');

  const onChange = (newValue) => {
    setLocationMethod(newValue);
  };

  const resetFields = () => {
    setSelectedStreet(null);
    setSelectedCity(null);
    setSelectedStreetNumber(null);
    setSelectedBuildingNumber(null);

    setData(null);
    //localStorage.removeItem(`SITE-FEASIBILITY`);
  }

  return (
    <Container fluid className='m-0 quoteSiteContainer'>
      <Row>
        <Row className='content pb-3' style={{ margin: 'auto' }}>
          {(isLoadingContent) && (
            <div className='isLoading item-center'>
              <Spinner animation="grow" variant="light" />
            </div>
          )}
          <Col className="px-1 py-1">
            <Row className='p-1'>
              <Form.Group as={Col} md={3} controlId="CitySelection" >
                <p className='label-form'>{t('FORMS.City')}</p>
                <AsyncSelect
                  className="AdminNewUSer__AsyncSelect_Company"
                  cacheOptions
                  //defaultValue=''
                  //isClearable
                  value={selectedCity}
                  noOptionsMessage={() => t('OTHERS.Min3CharLabel')}
                  loadOptions={loadMunicipality_delayed}
                  onChange={handleCity}
                  getOptionLabel={(e) => e.nome}
                  getOptionValue={(e) => e.pk}
                  styles={customStyles}
                  placeholder={t('NEWQUOTE.SITE.SelectCity')}
                //isDisabled={false}
                />
              </Form.Group>
              <Form.Group as={Col} md={4} controlId="StreetSelection">
                <p className='label-form'>{t('FORMS.Street')}</p>
                <AsyncSelect
                  className="AdminNewUSer__AsyncSelect_Company"
                  cacheOptions
                  //defaultValue=''
                  //isClearable
                  noOptionsMessage={() => t('OTHERS.Min3CharLabel')}
                  value={selectedStreet}
                  loadOptions={loadStreets_delayed}
                  onChange={handleStreet}
                  getOptionLabel={(e) => e.indirizzo}
                  getOptionValue={(e) => e.indirizzo}
                  styles={customStyles}
                  placeholder={t('NEWQUOTE.SITE.SelectStreet')}
                  isDisabled={!selectedCity}
                />
              </Form.Group>
              <Form.Group as={Col} md={2} controlId="StreetNumber">
                <p className='label-form'>{t('FORMS.StreetNumLabel')}</p>
                <AsyncSelect
                  className="AdminNewUSer__AsyncSelect_Company"
                  cacheOptions
                  //defaultValue=''
                  //isClearable
                  //key={selectedStreet == null ? 'key_StreetNumber' : selectedStreet.codiceIstat}
                  key={!selectedStreet ? null : 'key_Street_' + selectedStreet.codiceEgon}
                  defaultOptions
                  noOptionsMessage={() => t('OTHERS.MinCharLabel')}
                  value={selectedStreetNumber}
                  loadOptions={loadStreetNumber}
                  onChange={handleStreetNumber}
                  getOptionLabel={(e) => e.civico}
                  getOptionValue={(e) => e.civico}
                  styles={customStyles}
                  classNamePrefix="asyncselect"
                  placeholder={t('NEWQUOTE.SITE.SelectStreetNumber')}
                  isDisabled={!selectedStreet}
                />
              </Form.Group>
              <Form.Group as={Col} md={2} controlId="BuildingNumber">
                <p className='label-form'>{t('FORMS.BuildingNumberLabel')}</p>
                <AsyncSelect
                  className="AdminNewUSer__AsyncSelect_Company"
                  cacheOptions
                  //defaultValue=''
                  //isClearable
                  //key={selectedStreetNumber == null ? 'key_BuildingNumber' : selectedStreetNumber}
                  key={!selectedStreetNumber ? null : 'key_StreetNumber_' + selectedStreetNumber.civico}
                  defaultOptions
                  noOptionsMessage={() => t('OTHERS.NoDataMessage')}
                  value={selectedBuildingNumber}
                  loadOptions={loadBuildingNumber}
                  onChange={handleBuildingNumber}
                  getOptionLabel={(e) => e.scala}
                  getOptionValue={(e) => e.scala}
                  classNamePrefix="asyncselect"
                  styles={customStyles}
                  placeholder={t('NEWQUOTE.SITE.SelectBuildingNumber')}
                  isDisabled={(!selectedStreetNumber) || (!hasBuildingNumbers)}
                />
              </Form.Group>
              <Form.Group as={Col} md={1} className="item-center">
                <p className='label-form'><br /></p>
                <span>
                  <Button id={`resetBut`} onClick={() => resetFields()} className="m-0 p-0 btn btn-sm searchButton"><img src={Close} /></Button>
                </span>
              </Form.Group>
            </Row>
          </Col>
          <Row>
            {((listData != null) && (listData.length > 0)) ? (
              <QuoteCoverageTable
                istat={tableParams.istat}
                egon={tableParams.egon}
                civico={tableParams.civico}
                scala={tableParams.scala}
                data={listData}
                city={selectedCity?.nome}
                particellaToponomastica={selectedStreet?.part_top}
                street={!selectedStreet ? '' : selectedStreet.strada}
                snumber={!selectedStreetNumber ? '' : selectedStreetNumber.civico}
                bnumber={!selectedBuildingNumber ? '' : selectedBuildingNumber.scala}
                key={`FeasibilityCoverageTable`}
              />
            ) : (
              <Col className="item-center">{validated ? <p>{t('NEWQUOTE.COVERAGE.NoServices')}</p> : null}</Col>
            )}
          </Row>
        </Row>
      </Row>
    </Container>
  );
};

export default FeasibilitySite;
